export { default as ViewDocumentPage } from './view-document-page.component';
export * from './view-document-page.component';